var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Loader, Message } from "semantic-ui-react";
import { postWithAuthn } from "../RequestHelpers";
var SendPoReminderModal = /** @class */ (function (_super) {
    __extends(SendPoReminderModal, _super);
    function SendPoReminderModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
                error: false
            }, function () {
                postWithAuthn("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/email-po-reminder")
                    .then(function (resp) {
                    if (resp.ok) {
                        _this.setState({
                            loading: false,
                            success: true
                        });
                    }
                    else {
                        _this.setState({
                            loading: false,
                            error: true
                        });
                    }
                }).catch(function (rej) {
                    console.error("Couldn't send PO reminder: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            error: false,
            msg: ''
        };
        return _this;
    }
    SendPoReminderModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Email sent."),
            this.state.error &&
                React.createElement(Message, { negative: true }, "Email could not be sent."),
            React.createElement(Button, { disabled: this.state.success, icon: 'mail', label: 'Send mail', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return SendPoReminderModal;
}(React.PureComponent));
export default SendPoReminderModal;
//# sourceMappingURL=SendPoReminderModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/SendPoReminderModal.js
// module id = 1263
// module chunks = 0